module.exports = __webpack_public_path__ + "images/Fitbit-5f2498.png";